import {combineReducers} from "redux";
import {reduceRequestState, reduceResponse, RequestState} from "@web2/ap-request-state";

import {userSessionRestoreActionTypes} from "../../app/actions/restore_session";
import {fetchUserInfoActionTypes} from "../actions/get_user_info";
import {userIsAuthenticatedActionTypes} from "../actions/login";

export interface UserData {
    email: string;
    member: number;
    pk: number;
}

export interface UserInfoStore {
    userData: UserData | null;
    requestState: RequestState;
    isAuthenticated: boolean;
    userSessionRestoreRequestState: RequestState;
}

export const userInfoReducer = combineReducers({
    userData: reduceResponse(fetchUserInfoActionTypes),
    requestState: reduceRequestState(fetchUserInfoActionTypes),
    isAuthenticated: reduceResponse(userIsAuthenticatedActionTypes, false),
    userSessionRestoreRequestState: reduceRequestState(userSessionRestoreActionTypes)
});
